<template>
	<div>
		<v-btn
			@click="deleteDbHandler"
			rounded
			class="px-4"
			color="error"
			:loading="isLoading"
			:class="{ 'v-btn--disabled': false }"
		>
			Delete Local Database
			<template v-slot:loader>
				<v-progress-circular indeterminate />
			</template>
		</v-btn>
		<v-snackbar v-model="snackbarIsVisible" :timeout="2000">
			{{ snackbarMessage }}
		</v-snackbar>
	</div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api';
import { clearAllStores } from '@/services/indexedDBService';

export default defineComponent({
	setup() {
		const isLoading = ref(false);
		const snackbarMessage = ref('');
		const snackbarIsVisible = ref(false);

		async function deleteDbHandler() {
			isLoading.value = true;
			try {
				await clearAllStores();
				snackbarMessage.value = 'Successfully cleared local database';
				snackbarIsVisible.value = true;
			} catch (err) {
				snackbarMessage.value = 'Failed to clear local database';
				snackbarIsVisible.value = true;
			}

			isLoading.value = false;
		}

		return {
			deleteDbHandler,
			isLoading,
			snackbarMessage,
			snackbarIsVisible,
		};
	},
});
</script>

<style></style>
